import { TitleBar } from "../components/TitleBar";

interface IProps {
  title: string;
  header?: string;
  text?: string;
  children: JSX.Element[];
  className?: string;
}

export const Cards = ({ title, header, text, children, className }: IProps) => {
  return (
    <section
      className={`flex w-full justify-center items-center relative ${className}`}
    >
      <div className={"flex w-full flex-col px-2 py-16 md:px-32 md:py-40"}>
        <TitleBar title={title} header={header || ""} text={text} />
        <ul
          className={
            "flex flex-col md:flex-row flex-wrap justify-center px-4 md:px-0 pt-8 md:pt-16 gap-8 md:gap-24"
          }
        >
          {children.map((ch) => (
            <li>{ch}</li>
          ))}
        </ul>
      </div>
    </section>
  );
};
